import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * Fetches the whole list in one shot, like `FetchInterviews`: the screen only ever paginates
 * client-side, `fetchDocuments` walks every server page itself, via `getPaginated`.
 */
class FetchDocuments {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
	) {
		Object.freeze(this);
	}
}

export default FetchDocuments;
